import Store from '@/store'
import RestApi from '@/config/api_config'

const reject = (baseUrl, uri, id) => {
    Store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
    RestApi.deleteData(baseUrl, `${uri}/${id}`).then(response => {
        if (response.success) {
            Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
            window.vm.$toast.success({
                title: window.vm.$t('globalTrans.success'),
                message: window.vm.$t('globalTrans.rejectApplicationStatusMsg'),
                color: '#D6E09B'
            })
            const notification = response.notification
            if (notification && Store.state.emitNotification) {
                this.$socket.emit('send-notification', notification)
            }
        } else {
            window.vm.$toast.error({
                title: 'Error',
                message: 'Operation failed! Please, try again.'
            })
        }
        // Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
    })
}
const rejectApplication = (baseUrl, uri, id) => {
    window.vm.$swal({
        title: window.vm.$t('globalTrans.rejectApplicationMsg'),
        showCancelButton: true,
        confirmButtonText: window.vm.$t('globalTrans.yes'),
        cancelButtonText: window.vm.$t('globalTrans.no'),
        focusConfirm: false
    }).then((result) => {
        if (result.isConfirmed) {
            reject(baseUrl, uri, id)
        }
    })
}

export default rejectApplication
